import './S_TimePeriodSelector.scss';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faCalendar, faCalendarDay, faCalendarWeek } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { AutocompleteOption, ListItemDecorator } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../inputs/select/Select';

export enum TimePeriod {
  All = 10,
  Day = 20,
  Week = 25,
  Month = 30,
  DateRange = 40,
}

interface S_TimePeriodSelectorProps {
  selectedTimePeriod: TimePeriod;
  customLabels?: Record<string, string>;
  includeCustomRangeOption?: boolean;
  onPeriodChange: (period: TimePeriod) => Promise<void>;
}

export const S_TimePeriodSelector = observer((props: S_TimePeriodSelectorProps): ReactElement => {
  const { t } = useTranslator();
  const { onPeriodChange, selectedTimePeriod } = props;

  const options = [
    { value: TimePeriod.All, icon: faCalendar, label: t('selects.timePeriodSelector.all') },
    { value: TimePeriod.Day, icon: faCalendarDay, label: t('selects.timePeriodSelector.day') },
    { value: TimePeriod.Week, icon: faCalendarWeek, label: t('selects.timePeriodSelector.week') },
    { value: TimePeriod.Month, icon: faCalendarAlt, label: t('selects.timePeriodSelector.month') },
  ];

  if (props.includeCustomRangeOption) {
    options.push({ value: TimePeriod.DateRange, icon: faCalendarAlt, label: t('selects.timePeriodSelector.date_range') });
  }
  return (
    <div className='s-time-period-selector'>
      <Select
        value={options.find((x) => x.value === selectedTimePeriod)}
        onChange={(_, v) => {
          void onPeriodChange(v.value ?? TimePeriod.All);
        }}
        options={options}
        renderOption={(props, option) => (
          <AutocompleteOption {...props}>
            <ListItemDecorator>
              <FontAwesomeIcon icon={option.icon} />
            </ListItemDecorator>
            {option.label}
          </AutocompleteOption>
        )}
      />
    </div>
  );
});
